export const GENERATE_PASSWORD_BUTTON = 'app.changePassword.password.generatePasswordButton'
